import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { createApp } from '@backstage/frontend-defaults';
import vwtechLibsPlugin from '@internal/backstage-plugin-vwtech-libs/alpha';
import bugsyPlugin from '@internal/backstage-plugin-bugsy/alpha';
import techRadarPlugin from '@internal/backstage-plugin-tech-radar';
import vendorPerformancePlugin from '@internal/backstage-plugin-vendor-performance';
import archDrawioPlugin from '@internal/backstage-plugin-arch-drawio';
import sheriffAdminPlugin from '@internal/backstage-plugin-sheriff-admin';
import adAmsPlugin from '@internal/backstage-plugin-ad-ams';

import { techDocsReportIssueAddonModule } from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import { navModule } from './modules/nav';
import { appModule } from './modules/app';
import { apiDocsModule } from './modules/apiDocs';
import { catalogImportModule, catalogModule } from './modules/catalog';
import { catalogGraphModule } from './modules/catalogGraph';
import { scaffolderModule } from './modules/scaffolder';
import { searchModule } from './modules/search';
import { techdocsClickableImageLinksModule } from './modules/techdocs';

const app = createApp({
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
  features: [
    apiDocsPlugin,
    apiDocsModule,
    catalogPlugin,
    catalogImportPlugin,
    catalogGraphPlugin,
    catalogGraphModule,
    orgPlugin,
    scaffolderPlugin,
    scaffolderModule,
    searchPlugin,
    searchModule,
    techdocsPlugin,
    userSettingsPlugin,
    appModule,
    navModule,
    catalogModule,
    catalogImportModule,
    techdocsClickableImageLinksModule,
    techDocsReportIssueAddonModule,
    vwtechLibsPlugin,
    bugsyPlugin,
    techRadarPlugin,
    vendorPerformancePlugin,
    archDrawioPlugin,
    sheriffAdminPlugin,
    adAmsPlugin,
  ],
});

export default app.createRoot();
